export enum CreateOnsiteInterviewSteps {
  Reviews = 'reviews',
  WorkDetails = 'work-details',
}

export type TCreateOnsiteInterviewPageRoutes = { id: string };

export type TCreateOnsiteInterviewPageLocationState = {
  invitedProfessionals?: Array<{ label: string; value: string }>;
  isAfterJobPosting?: boolean;
};
